import { Component, signal, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { BannerComponent } from './shared/components/banner/banner.component';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, BannerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  title = 'accounts-ucc';
  showBanner = signal(true);

  ngOnInit() {
    document.querySelector('app-root')?.removeAttribute('ng-version');

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;
        const hiddenRoutes = ['/help', '/privacy-policy'];
        const shouldHide = hiddenRoutes.some((route) => url.startsWith(route));

        this.showBanner.set(!shouldHide);
      });
  }
}
